import {
  whyStatecsCtxP1,
  whyStatecsCtxP2,
  ourValuesCtx,
  whyStatecsCtxP3,
} from '@/constants/Article/articleContext';

export const whyStatecs = {
  header: 'Why STATECS?',
  linkId: 'why-statecs',
  context: {
    p1: whyStatecsCtxP1,
    p2: whyStatecsCtxP2,
    p3: whyStatecsCtxP3,
  },
};

export const ourValues = {
  header: 'Our Values',
  linkId: 'our-values',
  context: {
    p1: ourValuesCtx,
  },
};
